// AIDEV-NOTE: Firefox PWA-install detection. Firefox never fires `beforeinstallprompt`,
// so there is no programmatic install path in any Firefox build. Android Firefox CAN still
// install manually (menu -> "Install" / "Add to Home screen"). On desktop it depends on the
// OS: Windows ships "Taskbar Tabs" (Web Apps) enabled by default — an "Add tab to taskbar"
// button in the URL bar opens an app-style window and offers to pin it to the taskbar. macOS
// has no equivalent and Linux keeps it behind a pref, so both are treated as unsupported and
// the prompt is suppressed there rather than showing Chromium's "Install app" steps, which
// don't exist in Firefox's menu.
// iOS Firefox (FxiOS) is WebKit and is handled by the iOS guides in `~/lib/ios-install`.

function getUserAgent(): string {
    if (typeof navigator === "undefined") return "";
    return navigator.userAgent;
}

export function isFirefox(): boolean {
    const ua = getUserAgent();
    // Exclude FxiOS — iOS Firefox is WebKit and uses the iOS Add to Home Screen flow.
    return /Firefox\//.test(ua) && !/FxiOS/.test(ua);
}

export function isAndroidFirefox(): boolean {
    return isFirefox() && /Android/.test(getUserAgent());
}

export function isDesktopFirefox(): boolean {
    return isFirefox() && !/Android|Mobile|Tablet/.test(getUserAgent());
}

// AIDEV-NOTE: Desktop Firefox on Windows is the one desktop build with a real install path
// (Taskbar Tabs). `navigator.platform` is deprecated but still populated ("Win32") and is a
// useful fallback when the UA is reduced/spoofed.
export function isWindowsFirefox(): boolean {
    if (!isDesktopFirefox()) return false;
    const platform =
        typeof navigator === "undefined" ? "" : navigator.platform ?? "";
    return /Windows/.test(getUserAgent()) || /Win/.test(platform);
}
